__turbopack_context__.v({
  "card": "comboBracket-module-scss-module__D4Ahpa__card",
  "cards": "comboBracket-module-scss-module__D4Ahpa__cards",
  "explanation": "comboBracket-module-scss-module__D4Ahpa__explanation",
  "factor": "comboBracket-module-scss-module__D4Ahpa__factor",
  "factorIcon": "comboBracket-module-scss-module__D4Ahpa__factorIcon",
  "factorList": "comboBracket-module-scss-module__D4Ahpa__factorList",
  "factors": "comboBracket-module-scss-module__D4Ahpa__factors",
  "label": "comboBracket-module-scss-module__D4Ahpa__label",
  "links": "comboBracket-module-scss-module__D4Ahpa__links",
  "notLegal": "comboBracket-module-scss-module__D4Ahpa__notLegal",
  "note": "comboBracket-module-scss-module__D4Ahpa__note",
  "otherCombos": "comboBracket-module-scss-module__D4Ahpa__otherCombos",
  "panel": "comboBracket-module-scss-module__D4Ahpa__panel",
  "placeholders": "comboBracket-module-scss-module__D4Ahpa__placeholders",
  "raised": "comboBracket-module-scss-module__D4Ahpa__raised",
  "raisedIcon": "comboBracket-module-scss-module__D4Ahpa__raisedIcon",
  "tag": "comboBracket-module-scss-module__D4Ahpa__tag",
  "tagDescription": "comboBracket-module-scss-module__D4Ahpa__tagDescription",
  "tagName": "comboBracket-module-scss-module__D4Ahpa__tagName",
  "tagRange": "comboBracket-module-scss-module__D4Ahpa__tagRange",
  "tagValue": "comboBracket-module-scss-module__D4Ahpa__tagValue",
});
